/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDividerColumns = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-4 3h-2V4h-3v1h-2V4H8v1H6V4H4v16h2v-1h2v1h3v-1h2v1h3v-1h2v1h2V4h-2zM8 15v2H6v-2zm5 0v2h-2v-2zm5 0v2h-2v-2zM8 11v2H6v-2zm5 0v2h-2v-2zm5 0v2h-2v-2zM8 7v2H6V7zm5 0v2h-2V7zm5 0v2h-2V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDividerColumns as DividerColumns };
